import type { SerializedProfileAsset } from 'fym-shared/src/music24/artistProfile';

/** The chip of one version in the Versions list (design b1 `.vers`). */
export type VersionChip = 'current' | 'older' | 'noFile' | 'making' | 'failed';

export interface VersionRow {
  asset: SerializedProfileAsset;
  chip: VersionChip;
  /** "Use this one": an older ready version that still has its file. */
  canUse: boolean;
}

/** The rows of the Versions list, the newest first. Pure. */
export function versionRows(versions: readonly SerializedProfileAsset[]): VersionRow[] {
  return [...versions]
    .sort((a, b) => b.version - a.version)
    .map((asset) => {
      let chip: VersionChip = 'older';
      if (asset.status === 'queued' || asset.status === 'rendering') {
        chip = 'making';
      } else if (asset.status === 'failed') {
        chip = 'failed';
      } else if (asset.current) {
        chip = 'current';
      } else if (asset.fileRemoved || asset.url === null) {
        chip = 'noFile';
      }
      return { asset, chip, canUse: chip === 'older' };
    });
}
